import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import ContactsList from './contacts-list';
import ContactsListNoResults from './contacts-list-no-results';
import './styles.css';

const ContactsContainerComponent = ({ viewer, filter, loadMore, changeRepVisitsContactNotes, onEmptyResults }) => {
  const hasContacts = !!get(viewer, 'repVisitsContacts.edges.length');
  const hasNextPage = !!get(viewer, 'repVisitsContacts.pageInfo.hasNextPage');

  if (hasContacts) {
    return (
      <ContactsList
        contacts={get(viewer, 'repVisitsContacts.edges', [])}
        hasNextPage={hasNextPage}
        loadMore={loadMore}
        changeRepVisitsContactNotes={changeRepVisitsContactNotes}
      />
    );
  } else {
    if (filter) {
      return (<ContactsListNoResults />);
    }
    if (onEmptyResults) {
      onEmptyResults();
    }
    return null;
  }
};

export default ContactsContainerComponent;

ContactsContainerComponent.propTypes = {
  viewer: PropTypes.object,
  filter: PropTypes.string,
  changeRepVisitsContactNotes: PropTypes.func,
  loadMore: PropTypes.func,
  onEmptyResults: PropTypes.func,
};
